import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ChatButtonComponent } from '@web-bankir/shared/components/chat-button';
import { GlobalLoaderComponent } from '@web-bankir/shared/components/global-loader';
import { ToastComponent } from '@web-bankir/ui-kit/components/toast';
import { HeaderDirective } from '@web-bankir/ui-kit/directives/header';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderDirective,
    ToastComponent,
    GlobalLoaderComponent,
    ChatButtonComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
}
